import {
  Component,
  Input,
} from '@angular/core';
import { BaseDropdownComponent } from '../_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'simple-dropdown',
  templateUrl: 'simple-dropdown.component.html',
  styleUrls: ['simple-dropdown.component.scss']
})
export class SimpleDropdownComponent extends BaseDropdownComponent {

  @Input() declare items: any[];
  @Input() alignmentRight: boolean = false;
  @Input() currentValue: string = '';
  @Input() arrowColor: string = '';
  @Input() isLanguage: boolean = false;

  onSelectedChange(selected: any) {
    this.currentValue = selected.code;
    this.selectedItem = selected;
    this.selectedChange.emit(selected);
  }

}
